export default "__VITE_ASSET__Yx6KsPUf__"